module.exports = __webpack_public_path__ + "static/media/wave2.72b55df1.svg";